/**
 * Устанавливает наблюдение за изменением высоты и ширины html-элемента
 */
export class ObserverOnResize {

  watchedElements: IElementData[];

  constructor() {
    this.watchedElements = [];
    window.addEventListener('resize', this.checkForChanges);
  }

  /**
   * Проверяет изменения размеров html-элемента
   */
  checkForChanges = () => {
    if (this.watchedElements.length > 0) {
      this.watchedElements.forEach((watchedElement) => {
        if (watchedElement.element.offsetWidth !== watchedElement.width
          || watchedElement.element.offsetHeight !== watchedElement.height) {
          watchedElement.width = watchedElement.element.offsetWidth;
          watchedElement.height = watchedElement.element.offsetHeight;
          watchedElement.callback();
        }
      });
    }
  }

  /**
   * Добавляет html-элемента к списку наблюдаемых
   * @param element
   * @param callback
   */
  addForObservation = (element: HTMLElement, callback: () => void) => {
    this.watchedElements.push({
      element,
      width: element.offsetWidth,
      height: element.offsetHeight,
      callback,
    });
  }

  /**
   * Отключает наблюдение за всеми ранее внесенными html-элементами
   */
  disconnect = () => {
    window.removeEventListener('resize', this.checkForChanges);
  }
}
